import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CPESharedModule } from '../shared/shared.module';
import { UIModule } from 'libs/ui';
import {
  FluidDetailInfoComponent,
  FluidFormFactory,
  IfactsMaterialAssignmentDialogComponent
} from './components';
import { VIDASharedModule } from 'libs/shared/vida-shared.module';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { PopoverModule } from 'primeng/popover';
import { InputMaskModule } from 'primeng/inputmask';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TabsModule } from 'primeng/tabs';

const thirdPartyModules = [
  CommonModule,
  FormsModule,
  TabsModule,
  AutoCompleteModule,
  InputMaskModule,
  PopoverModule,
  CheckboxModule,
  TooltipModule
];

const services = [
  FluidFormFactory
];

const adapters = [
];

const components = [
  FluidDetailInfoComponent,
  IfactsMaterialAssignmentDialogComponent
];

@NgModule({
  imports: [
    ...thirdPartyModules,
    UIModule,
    CPESharedModule,
    VIDASharedModule
  ],
  declarations: [
    ...components
  ],
  exports: [
    ...components
  ],
  providers: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FluidsModule {
  static forRoot(): ModuleWithProviders<FluidsModule> {
    return {
      ngModule: FluidsModule,
      providers: [
        ...services,
        ...adapters
      ]
    };
  }
}
